import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { BiSupport } from "react-icons/bi";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { MdOutlineLocalCarWash } from "react-icons/md";
import Aos from "aos";
import React, { useEffect } from "react";

import ImageWithBasePath from "../../core/data/img/ImageWithBasePath"; 


const Why = () => {
    useEffect(() => {
        Aos.init({ duration: 1200, once: true });
    }, []);
    return (
        <>

            <section className="section why-choose py-3">
                <div className="choose-left">

                </div>
                <div className="container">

                    <div className="section-heading mb-2" data-aos="fade-down">
                        <h2>Why Choose Us</h2>
                    </div>

                    <div className="why-choose-group">
                        <div className="row">
                            <div
                                className="col-lg-4 col-md-6 col-12 d-flex"
                                data-aos="fade-down"
                            >
                                <div className="card flex-fill my-1">
                                    <div className="card-body p-2">
                                        <div className="choose-img bg-primary p-0">
                                            <LiaFileInvoiceDollarSolid style={{
                                                width: 40,
                                                height: 40,
                                                color: "#fff"
                                            }} />
                                        </div>
                                        <div className="choose-content">
                                            <h4>Flexible Payments</h4>
                                            <p>
                                                Long-term rentals, daily payment options.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6 col-12 d-flex"
                                data-aos="fade-down"
                            >
                                <div className="card flex-fill my-1">
                                    <div className="card-body p-2">
                                        <div className="choose-img bg-primary p-0">
                                            <ImageWithBasePath
                                                src="assets/img/icons/bx-crown.svg"
                                                alt=""
                                            />
                                        </div>
                                        <div className="choose-content">
                                            <h4>Exclusivity</h4>
                                            <p>
                                                Book a car exclusively for your term—no one else can claim it until you&#39;re done.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6 col-12 d-flex"
                                data-aos="fade-down"
                            >
                                <div className="card flex-fill my-1">
                                    <div className="card-body p-2">
                                        <div className="choose-img bg-primary p-0">
                                            <MdOutlineLocalCarWash style={{
                                                width: 40,
                                                height: 40,
                                                color: "#fff"
                                            }} />
                                        </div>
                                        <div className="choose-content">
                                            <h4>All-Inclusive</h4>
                                            <p>
                                                Insurance, maintenance, and unlimited mileage are all part of the package
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div
                                className="col-lg-4 col-md-6 col-12 d-flex"
                                data-aos="fade-down"
                            >
                                <div className="card flex-fill my-1">
                                    <div className="card-body p-2">
                                        <div className="choose-img bg-primary p-0">
                                            <BiSupport style={{
                                                width: 40,
                                                height: 40,
                                                color: "#fff"
                                            }} />

                                        </div>
                                        <div className="choose-content">
                                            <h4>Always Here</h4>
                                            <p>
                                                24/7 text support and 12-hour phone support to keep you moving.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
       

        </>
    );
};

export default Why;
